import React, { useState } from 'react';
import { RANKING_DATA } from '../content/ranking';
import { ASSETS } from '../assetManifest';

function Ranking({ app }) {
  const [activeTab, setActiveTab] = useState('top');

  return (
    <div className="h-full w-full flex flex-col relative overflow-auto"
      style={{
        background: 'linear-gradient(180deg, #8856F6 0%, #40B8F4 100%)',
        opacity: '0.778855'
      }}
    >
      <div className="max-w-md mx-auto w-full p-6">
        <h2 className="text-3xl font-bold text-amber-300 text-center font-['Arial'] mb-6">RANKINGS</h2>
        
        <div className="bg-black bg-opacity-5 rounded-xl p-6 mb-6 shadow-lg border border-white">
          <p className="text-2xl font-bold text-center font-['Arial']">
            <span className="text-slate-100">Your Rank: </span>
            <span className="text-green-400">#{RANKING_DATA.playerRank.rank}</span>
          </p>
          <p className="text-xl text-center mt-2 font-['Arial']">
            <span className="text-slate-100">Score: </span>
            <span className="text-green-400">{RANKING_DATA.playerRank.score}</span>
          </p>
        </div>

        <div className="flex mb-6 gap-4">
          <button
            className={`flex-1 py-3 px-4 text-center rounded-xl transition-all border border-white font-['Arial']
              ${activeTab === 'top' 
                ? 'bg-black bg-opacity-15 text-slate-100 font-bold shadow-lg'
                : 'bg-black bg-opacity-15 text-slate-100 hover:bg-opacity-25'
              }`}
            onClick={() => setActiveTab('top')}
          >
            Top Players
          </button>
          <button
            className={`flex-1 py-3 px-4 text-center rounded-xl transition-all border border-white font-['Arial']
              ${activeTab === 'nearby'
                ? 'bg-black bg-opacity-15 text-slate-100 font-bold shadow-lg'
                : 'bg-black bg-opacity-15 text-slate-100 hover:bg-opacity-25'
              }`}
            onClick={() => setActiveTab('nearby')}
          >
            Around You
          </button>
        </div>

        {activeTab === 'top' && (
          <div className="space-y-3">
            {RANKING_DATA.rankings.map(player => (
              <div key={player.rank} className="bg-black bg-opacity-[0.451022] rounded-xl p-4 flex items-center border border-white">
                <div className="w-8 text-center font-bold text-lg text-slate-100 mr-4 font-['Arial']">
                  {player.rank}
                </div>
                <div className="w-12 h-12 bg-[#D8D8D8] rounded-full mr-4 flex items-center justify-center flex-shrink-0 text-2xl border border-[#979797]">
                  {player.emoji}
                </div>
                <div className="flex-1">
                  <p className="text-slate-100 font-bold text-lg font-['Arial']">{player.name}</p>
                  <p className="text-base font-['Arial']">
                    <span className="text-slate-100 font-bold">Score: </span>
                    <span className="text-amber-300 font-bold">{player.score}</span>
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'nearby' && (
          <div className="space-y-3">
            {RANKING_DATA.nearbyPlayers.map(player => (
              <div 
                key={player.rank} 
                className={`bg-black bg-opacity-[0.451022] rounded-xl p-4 flex items-center border
                  ${player.name === 'YOU' 
                    ? 'border-green-400' 
                    : 'border-white'
                  }`}
              >
                <div className="w-8 text-center font-bold text-lg text-slate-100 mr-4 font-['Arial']">
                  {player.rank}
                </div>
                <div className="w-12 h-12 bg-[#D8D8D8] rounded-full mr-4 flex items-center justify-center flex-shrink-0 text-2xl border border-[#979797]">
                  {player.emoji}
                </div>
                <div className="flex-1">
                  <p className="text-slate-100 font-bold text-lg font-['Arial']">{player.name}</p>
                  <p className="text-base font-['Arial']">
                    <span className="text-slate-100 font-bold">Score: </span>
                    <span className="text-amber-300 font-bold">{player.score}</span>
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Ranking;
